<template>
  <div class="cart-widget">
    <div class="widget-header" :class="{spinner: loading}">{{ $t('shop.checkout.billing_method') }}</div>
    <div class="widget-content">
      <ul class="widget-options">
        <li v-for="(method, key) in methods" :key="key">
          <input type="radio" :id="'payment-method-'+method.id" v-model="method.selected" value="true"
                 @change="select(method)" class="checkbox light" name="payment-method"/>
          <label :for="'payment-method-'+method.id">{{ method.name[$i18n.locale] }}</label>
          <p>{{ method.description[$i18n.locale] }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ['methods', 'loading'],
  methods: {
    select (method) {
      this.$emit('input', method);
    }
  }
};
</script>
